import { render } from "./FramesList.vue?vue&type=template&id=7ee566c4&scoped=true"
import script from "./FramesList.vue?vue&type=script&lang=js"
export * from "./FramesList.vue?vue&type=script&lang=js"

import "./FramesList.vue?vue&type=style&index=0&id=7ee566c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee566c4"]])

export default __exports__